/**
 * Form Data Utilities
 * 
 * Functions for converting objects to FormData
 */

/**
 * Convert object to FormData
 * @param {Object} obj - Object to convert
 * @returns {FormData} FormData object
 */
export function objectToFormData(obj) {
  const fd = new FormData();

  Object.entries(obj).forEach(([key, value]) => {
    if (value instanceof File) {
      // Append file directly
      fd.append(key, value);
    } else if (Array.isArray(value) || typeof value === "object") {
      // JSON stringify arrays and objects
      fd.append(key, JSON.stringify(value));
    } else if (value !== undefined && value !== null) {
      // Append normal primitive values
      fd.append(key, value);
    }
  });

  return fd;
}

/**
 * Convert post object to FormData with special handling for tagged users/groups/pages
 * @param {Object} obj - Post object to convert
 * @returns {FormData} FormData object
 */
export function postObjectToFormData(obj) {
  const fd = new FormData();
  const taggedKeys = ["taggedUsers", "taggedGroups", "taggedPages"];

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    // Skip null or undefined values
    if (value === null || value === undefined) {
      return;
    }

    if (Array.isArray(value)) {
      if (key === "mediaFiles") {
        value.forEach((item) => {
          if (item instanceof File) {
            fd.append("media", item);
          }
        });
      } else if (key === "tags") {
        value.forEach((item) => {
          fd.append(`${key}[]`, item);
        });
      } else if (taggedKeys.includes(key)) {
        fd.append(key, JSON.stringify(value));
      } else {
        value.forEach((item) => {
          fd.append(`${key}[]`, item);
        });
      }
    } else if (typeof value === "object") {
      fd.append(key, JSON.stringify(value));
    } else {
      fd.append(key, value);
    }
  });

  return fd;
}

